import React from 'react';

import { Flexer, Button } from '@ontruck/orc';
import { StyledZeroReults } from './styled';

const t = {
  no_drivers: 'Service Fleet is empty, you can add a new one from the Carriers tab.',
  cta: 'Add a vehicle to My Fleet',
};

const MyFleetSection = ({ onAddClick, showAddOption }) => {
  return (
    <StyledZeroReults data-testid="my_fleet_zero_results">
      <Flexer.Parent flexDirection="column" alignItems="center">
        <Flexer.Child mBottom="S" data-testid="my_fleet_empty">
          {t.no_drivers}
        </Flexer.Child>
        {!!showAddOption && (
          <div>
            <Button
              text={t.cta}
              ghost
              skin="light"
              data-testid="my_fleet_empty_button"
              onClick={onAddClick}
            />
          </div>
        )}
      </Flexer.Parent>
    </StyledZeroReults>
  );
};

export default MyFleetSection;
